/**
 * Adds a duration in minutes to an HH:mm time string, wrapping at midnight.
 * Returns the original time string when inputs are invalid.
 */
export const addMinutesToTime = (time: string, minutes: number): string => {
  const [h, m] = time.split(':').map(Number)
  if (!Number.isFinite(h) || !Number.isFinite(m) || !Number.isFinite(minutes) || minutes < 0) return time
  const total = h * 60 + m + minutes
  const hh = Math.floor(total / 60) % 24
  const mm = total % 60
  return `${String(hh).padStart(2, '0')}:${String(mm).padStart(2, '0')}`
}

/**
 * Resolves the display end time for an activity.
 * Prefers the stored endTime; falls back to calculating from time + length (minutes).
 */
export const resolveActivityEndTime = (activity: {
  time?: string
  length?: number
  endTime?: string
}): string | undefined => {
  if (activity.endTime) return activity.endTime
  if (activity.time && activity.length != null && activity.length > 0) {
    return addMinutesToTime(activity.time, activity.length)
  }
  return undefined
}
